import React from 'react';
import merge from 'lodash/merge';
import {PremiumWrapperOverlay} from '../../PremiumWrapperOverlay';
import {Col, Form, Row} from 'react-bootstrap';
import ColorPicker from './ColorPicker';
import Ranges from '../../../system/ranges';
import {Action} from '../../../system/buttons';

const DEFAULT_CONFIG = {
  min: 50,
  max: 120,
  ranges: [
    {from: 50, to: 80, heartColor: '#00FF00'},
    {from: 80, to: 100, heartColor: '#FFFF00'},
    {from: 100, to: 120, heartColor: '#FF0000'},
  ],
};

export const DiabloEdit = (props) => {
  const [configuration, setConfiguration] = React.useState(
    merge({}, DEFAULT_CONFIG, props.configuration)
  );

  const updateConfiguration = (configPart: Partial<typeof DEFAULT_CONFIG>) => {
    const newConfiguration = {...configuration, ...configPart};
    setConfiguration(newConfiguration);
    props.onUpdate(newConfiguration);
  };

  const handleOnSave = () => {
    props.onSave(configuration);
  };

  return (
    <>
      <PremiumWrapperOverlay
        bi={{
          from: 'widget_edit_premium_update',
          id: props.id,
        }}
        disabled={!props.premiumUpdate}
      >
        <h4>BPM Configuration</h4>

        <Form.Group>
          <Row>
            <Col md="2">
              <Form.Label>Min</Form.Label>
              <Form.Control
                type="number"
                value={configuration.min}
                onChange={(e) =>
                  updateConfiguration({min: parseInt(e.target.value)})
                }
              />
            </Col>
          </Row>
        </Form.Group>

        <Form.Group>
          <Row>
            <Col md="2">
              <Form.Label>Max</Form.Label>
              <Form.Control
                type="number"
                value={configuration.max}
                onChange={(e) =>
                  updateConfiguration({max: parseInt(e.target.value)})
                }
              />
            </Col>
          </Row>
        </Form.Group>

        <Form.Group>
          <Ranges
            ranges={configuration.ranges}
            onRangesChange={(ranges) => updateConfiguration({ranges})}
            defaultRange={{
              from: DEFAULT_CONFIG.ranges[0].from,
              to: DEFAULT_CONFIG.ranges[0].to,
              heartColor: DEFAULT_CONFIG.ranges[0].heartColor,
            }}
            header={
              <Col md={3}>
                <Form inline>
                  <Col>Heart Color</Col>
                </Form>
              </Col>
            }
            rangeConfiguration={(range, onRangeChange) => (
              <Form inline>
                <ColorPicker
                  color={range?.heartColor}
                  onChangeComplete={(heartColor) =>
                    onRangeChange({...range, heartColor})
                  }
                />
              </Form>
            )}
          />
        </Form.Group>
      </PremiumWrapperOverlay>

      <Action onClick={handleOnSave}>Save settings</Action>
    </>
  );
};
